import React from 'react';
import images from 'assets/img';
import HeaderComponent from 'components/HeaderComponent';
// import BreadCrumb from 'components/BreadCrumb';
import { useDispatch } from 'react-redux';
import { showModal } from 'store/slices/miscSlice';
import AddCredit from './AddCredit';

export default function CreditDetails() {
  const dispatch = useDispatch()

  return (
    <>
      {/* <BreadCrumb 
        items={[
          {
            name: 'Promo',
            url: '/promo'
          },
          {
            name: 'Credit'
          }
        ]}
      /> */}
      <section className="bg-white p-5 lg:p-10 rounded-2xl flex flex-col items-center w-full mb-8 lg:w-full">
      {/* <section className="bg-white p-5 lg:p-10 rounded-2xl flex flex-col items-center w-[340px] mb-8 lg:w-full"> */}
        <div className="w-full border-b">
          <HeaderComponent 
            title="Credit"
            btnText="Add credit"
            // btnClick={() => dispatch(showModal({
            //   title: 'Payment',
            //   content: AddCredit,
            //   url: '',
            //   submitText: 'Proceed',
            //   dispatchAction: '',
            //   validation: '',
            //   method: 'post',
            //   validation: '',
            //   // stepper: ['Amount', 'PIN'],
            //   values: [
            //     {
                  // amount: '',
                  // pin: ''
            //     }
            //   ],
            //   action: ''
            // }))}
            btnClick={() => dispatch(showModal({
              title: 'Payment',
              content: AddCredit,
              url: '',
              submitText: 'Proceed',
              dispatchAction: '',
              validation: '',
              values: [
                {
                  amount: '',
                  pin: ''
                }
              ],
              action: ''
            }))}
          />
        </div>
        
        <div className="w-full flex h-96 items-center justify-center flex-col">
          <div className="h-28 w-28 rounded-full  bg-success bg-opacity-10 flex items-center mb-8">
            <images.Sale classList="m-auto w-12 h-12" />
          </div>

          <p className="text-secondary">No credit made yet</p>
        </div>
      </section>
    </>
  )
}
